// extracted by mini-css-extract-plugin
module.exports = {"TwoColumnContentSection":"TwoColumnContent_TwoColumnContentSection__45E3l","WYSIWYG":"TwoColumnContent_WYSIWYG__fKYFf"};